/** 12px label + 13px×2 padding (px avoids :root 80% rem shrink). */
export const SIDEBAR_MENU_ITEM_BASE =
	"sidebar-nav-item flex min-h-[47px] w-full items-center gap-3 rounded-none border-b border-white/40 px-[18px] py-[13px] font-sans text-[12px] font-normal whitespace-nowrap transition focus:outline-none relative";

/** Collapsed sidebar — icon-only row, same height and divider. */
export const SIDEBAR_MENU_ITEM_COLLAPSED =
	"sidebar-nav-item flex min-h-[47px] w-full items-center justify-center gap-3 rounded-none border-b border-white/40 px-3 py-[13px] font-sans text-[12px] font-normal whitespace-nowrap transition focus:outline-none relative";

/** Second-level nested item — extra left inset. */
export const SIDEBAR_MENU_ITEM_NESTED =
	"sidebar-nav-item flex min-h-[47px] w-full items-center gap-3 rounded-none border-b border-white/40 pl-9 pr-[18px] py-[13px] font-sans text-[12px] font-normal whitespace-nowrap transition focus:outline-none relative";

/** Third-level nested item — deeper inset. */
export const SIDEBAR_MENU_ITEM_NESTED_DEEP =
	"sidebar-nav-item flex min-h-[47px] w-full items-center gap-3 rounded-none border-b border-white/40 pl-12 pr-[18px] py-[13px] font-sans text-[12px] font-normal whitespace-nowrap transition focus:outline-none relative";
